export default __webpack_public_path__ + "7f80fa380a3929e28ee369cfb3fe6d21.png";